export default __webpack_public_path__ + "media/images/react_icons/property/house-cf6a549cfe977611d9d3c7ced65c33af.svg";